// extracted by mini-css-extract-plugin
export default {"root":"axEaut","bg":"wW9c2R"};